// extracted by mini-css-extract-plugin
module.exports = {"contactLink":"Contact_contactLink__DyB7c","active":"Contact_active__2jUyo"};